import { useState } from "react";

const usePageHeaders = () => {
  const [drawer, setDrawer] = useState(false);

  const _openDrawer = () => {
    setDrawer(true);
  }

  const _closeDrawer = () => {
    setDrawer(false);
  }

  return {
    drawer,
    _openDrawer,
    _closeDrawer
  }
}

export default usePageHeaders;